module.exports = __webpack_public_path__ + "img/service-ico.59a2cee7.png";